<template>
  <div>
    <v-card>
      <v-row>
        <v-col cols="12" class="py-0">
          <v-img height="202" :src="storeProfile.bannerURL ? storeProfile.bannerURL : defaultBanner"></v-img>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4" class="d-flex flex-column justify-center">
                <div class="d-flex flex-column align-center">
                  <v-avatar size="90">
                    <img class="border-4-white white" :src="storeProfile.logoURL ? storeProfile.logoURL : defaultLogo">
                  </v-avatar>
                  <div>
                    <v-alert
                        dense
                        color="secondary white--text"
                        class="mb-2 mt-4"
                    >
                      <span class="font-weight-bold">
                          {{ storeProfile ? storeProfile.name : "Store Name" }}
                      </span>
                    </v-alert>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" sm="8">
                <div>
                  <div class="d-flex align-center mb-2" v-if="storeProfile.mediaURL.website!==''">
                    <v-icon small class="mr-2" color="grey darken-1">mdi-web</v-icon>
                    <span class="grey--text text--darken-1">{{ storeProfile.mediaURL.website }}</span>
                  </div>
                  <div class="d-flex align-center mb-2" v-if="storeProfile.contact.phoneNumber!==''">
                    <v-icon small class="mr-2" color="grey darken-1">mdi-phone</v-icon>
                    <span class="grey--text text--darken-1">{{ storeProfile.contact.phoneNumber }}</span>
                  </div>
                  <div class="d-flex align-center mb-2" v-if="storeProfile.contact.email!==''">
                    <v-icon small class="mr-2" color="grey darken-1">mdi-email</v-icon>
                    <span class="grey--text text--darken-1">{{ storeProfile.contact.email }}</span>
                  </div>
                </div>

                <div class="d-flex align-center mb-2">
                  {{ storeProfile.description }}
                </div>

                <div class="d-flex">
                  <v-btn
                      v-if="storeAccount"
                      depressed
                      color="blue darken-1"
                      class="mr-4" dark
                      :to='{name: "payment", query: {storeAccount}}'
                  >
                    <v-icon class="mr-2">mdi-cash-fast</v-icon>
                    Payment
                  </v-btn>

                  <v-btn depressed class="mr-4" @click="toOpenseaMarket">
                    <v-img src="@/assets/images/OpenSeaLogo.png" class="my-4" width="102px" contain></v-img>
                  </v-btn>

                  <v-icon
                      color="light-blue darken-4"
                      class="mr-4"
                      size="28"
                      v-if="storeProfile.mediaURL.facebook"
                      @click="onClickMediaIconHandle(storeProfile.mediaURL.facebook)"
                      :href="storeProfile.mediaURL.facebook"
                  >
                    mdi-facebook
                  </v-icon>
                  <v-icon
                      color="light-blue lighten-1"
                      class="mr-4"
                      size="28"
                      v-if="storeProfile.mediaURL.twitter"
                      @click="onClickMediaIconHandle(storeProfile.mediaURL.twitter)"
                      :href="storeProfile.mediaURL.twitter"
                  >
                    mdi-twitter
                  </v-icon>
                  <v-icon
                      color="red darken-2"
                      class="mr-4"
                      size="28"
                      v-if="storeProfile.mediaURL.youtube"
                      @click="onClickMediaIconHandle(storeProfile.mediaURL.youtube)"
                      :href="storeProfile.mediaURL.youtube"
                  >
                    mdi-youtube
                  </v-icon>
                  <v-icon
                      color="pink lighten-1"
                      class="mr-4"
                      size="28"
                      v-if="storeProfile.mediaURL.instagram"
                      @click="onClickMediaIconHandle(storeProfile.mediaURL.instagram)"
                      :href="storeProfile.mediaURL.instagram"
                  >
                    mdi-instagram
                  </v-icon>
                  <v-icon
                      color="purple lighten-1"
                      class="mr-4"
                      size="28"
                      v-if="storeProfile.mediaURL.discord"
                      @click="onClickMediaIconHandle(storeProfile.mediaURL.discord)"
                      :href="storeProfile.mediaURL.discord"
                  >
                    mdi-discord
                  </v-icon>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>

const defaultBanner = require("@/assets/images/storeDefaultBanner.png")
const defaultLogo = require("@/assets/images/decentralStoreLogo.png")

export default {
  name: "StoreProfile",
  props: {
    storeProfile: {
      default: null,
      type: Object
    },
    nftContract: String,
    storeAccount: String
  },

  data() {
    return {
      defaultBanner,
      defaultLogo
    }
  },
  methods: {
    onClickMediaIconHandle(hrefLink) {
      hrefLink = hrefLink.match(/^http[s]?:\/\//) ? hrefLink : 'http://' + hrefLink;
      window.open(hrefLink)
    },
    toOpenseaMarket() {
      const openseaStore = process.env.VUE_APP_OPENSEA_SEARCH_PREFIX + this.nftContract
      window.open(openseaStore,'_blank')
    }
  }
}
</script>

<style scoped>

</style>